import { BoxProps, Menu, MenuItem } from '@material-ui/core';
import { LoanStatusExternal } from '@nemuru-eng/js-api-client';
import React, { useState } from 'react';

import { StyledButton } from '@/components/modules/Metrics/shared/components/StyledButton';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

import { ScoreCardMetricKey } from '../../shared/types/ScoreCardMetricKey';

interface StyledSelectorProps extends BoxProps {
  currentSelectedValue: LoanStatusExternal | ScoreCardMetricKey;
  setSelectedValue;
  startIcon: string;
  selectOptions: LoanStatusExternal[] | ScoreCardMetricKey[];
}

export const StyledSelector = ({
  currentSelectedValue,
  setSelectedValue,
  selectOptions,
  startIcon,
}: StyledSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledButton
        value={currentSelectedValue}
        onClick={handleClick}
        color="default"
        startIcon={<Icon size={16}>{startIcon}</Icon>}
        endIcon={<Icon size={20}>expand_more</Icon>}
      />
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {selectOptions.map((value) => (
          <MenuItem
            dense
            key={value}
            value={value}
            onClick={() => {
              setSelectedValue(value);
              handleClose();
            }}
          >
            <Text tId={`${value}`} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
